import React from 'react';
import PropTypes from 'prop-types';
import Lottie from 'react-lottie';
import PublishInstructionsText from './PublishInstructionsText.jsx';
import PublishButtonAndTooltip from './PublishButtonAndTooltip.jsx';
import s from './PublishInstructions.module.scss';

const PublishInstructions = ({ animationOptions, handlePublishClick, isVisible, publishPending, status, stopDate, hasAssetsWritePermission }) => (
    <div className={s.instructions}>
        <div className={s.textAndButton}>
            <PublishInstructionsText />
            <PublishButtonAndTooltip
                handlePublishClick={handlePublishClick}
                hasAssetsWritePermission={hasAssetsWritePermission}
                isVisible={isVisible}
                publishPending={publishPending}
                status={status}
                stopDate={stopDate}
            />
        </div>
        <div>
            <Lottie options={animationOptions} height={430} width={300} isStopped={status !== 'RUNNING'} isPaused={false} />
        </div>
    </div>
);

PublishInstructions.propTypes = {
    animationOptions: PropTypes.object.isRequired,
    handlePublishClick: PropTypes.func.isRequired,
    hasAssetsWritePermission: PropTypes.bool.isRequired,
    isVisible: PropTypes.bool.isRequired,
    publishPending: PropTypes.bool.isRequired,
    status: PropTypes.string.isRequired,
    stopDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]).isRequired,
};

export default PublishInstructions;
